import React, { useEffect, useState } from "react";
import TimePicker from "@components/TimePicker";
const isValidHHMM = (v) => /^\d{2}:\d{2}$/.test(v);

export default function CreateTaskModal({ open, onClose, onSubmit }) {
  const [taskName, setTaskName] = useState("");
  const [startTime, setStartTime] = useState("10:00");

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const inputBase =
    "h-12 w-full rounded-[16px] border border-[#D6D9E0] bg-white px-4 outline-none focus:border-[#2B7CFF]";

  const miniBtn =
    "h-8 px-3 rounded-full border border-[#D6D9E0] bg-white hover:bg-[#F7F8FA] transition text-[12px] font-medium text-[#111827]";

  const setNow = () => {
    const d = new Date();
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    setStartTime(`${hh}:${mm}`);
  };

  const submit = () => {
    const safeTime = isValidHHMM(startTime) ? startTime : "10:00";
    onSubmit?.({
      taskName: taskName.trim(),
      startTime: safeTime,
    });
  };

  return (
    <div className="fixed inset-0 z-[60]">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />

      <div className="absolute inset-0 grid place-items-center px-4">
        <div className="w-full max-w-[540px] bg-white rounded-[22px] border border-[#C8C8C8] shadow-[0_18px_40px_rgba(0,0,0,0.16)] p-7">
          {/* Header */}
          <div className="flex items-start justify-between gap-4">
            <div>
              <h3 className="text-[20px] font-semibold text-[#111827]">Создать задачу</h3>
              <p className="mt-1 text-[13px] text-[#6B7280]">
                Укажи название и время запуска. Аккаунты добавляются уже внутри задачи.
              </p>
            </div>

            <button
              className="w-10 h-10 rounded-full bg-[#F3F4F6] grid place-items-center hover:bg-[#EDEFF3] transition"
              onClick={onClose}
              title="Закрыть"
              type="button"
            >
              <i className="fa-solid fa-xmark text-[#111827]" />
            </button>
          </div>

          {/* Название */}
          <div className="mt-6 grid gap-2">
            <div className="text-[13px] font-medium text-[#374151]">Название</div>
            <input
              value={taskName}
              onChange={(e) => setTaskName(e.target.value)}
              className={inputBase}
              placeholder="Например: Подписка на группы"
            />
          </div>

          {/* Time card */}
          <div className="mt-6 rounded-[18px] border border-[#D6D9E0] p-4">
              <div className="text-[13px] font-semibold text-[#374151]">Время старта</div>

              <div className="mt-3 flex flex-wrap gap-2">
                <button type="button" className={miniBtn} onClick={() => setStartTime("10:00")}>
                  10:00
                </button>
                <button type="button" className={miniBtn} onClick={() => setStartTime("12:00")}>
                  12:00
                </button>
                <button type="button" className={miniBtn} onClick={() => setStartTime("18:00")}>
                  18:00
                </button>
                <button type="button" className={miniBtn} onClick={setNow}>
                  сейчас
                </button>
              </div>

              {/* ✅ твой отдельный красивый тайм-пикер */}
              <div className="mt-3">
                <TimePicker value={startTime} onChange={setStartTime} />
              </div>
          </div>

          {/* Footer */}
          <div className="mt-7 flex items-center justify-end gap-4">
            <button
              className="h-11 px-10 rounded-full border border-[#D6D9E0] bg-white hover:bg-[#F7F8FA] transition text-[14px] font-medium"
              onClick={onClose}
              type="button"
            >
              Отмена
            </button>

            <button
              className="h-11 px-10 rounded-full bg-[#2B7CFF] text-white shadow-[0_14px_30px_rgba(43,124,255,0.35)] hover:brightness-95 transition text-[14px] font-semibold"
              onClick={submit}
              type="button"
            >
              Создать
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
